// plugins.js
export const Plugins = [
  "advlist",
  "autolink",
  "autoresize",
  "link",
  "image",
  "lists",
  "charmap",
  "preview",
  "anchor",
  "pagebreak",
  "searchreplace",
  "wordcount",
  "visualblocks",
  "visualchars",
  "code",
  "fullscreen",
  "insertdatetime",
  "media",
  "nonbreaking",
  "save",
  "table",
  "directionality",
  "emoticons",
  "quickbars",
];
